/**
 * 初始化方法
 */
function getSession() {
  let sess = sessionStorage.getItem('session') // 获取session中的值
  if (!sess) { // session 如果不存在则随机生成一个并存入sessionStore
    sess = Math.random() * 1000 * 1000
    sessionStorage.setItem('session', sess)
  }
  return sess
}

export function getMetaData() {
  const metadata = {}
  metadata.session = getSession()
  metadata.token = sessionStorage.getItem('token')
  return metadata
}
export default getMetaData



// WEBPACK FOOTER //
// ./src/utils/request.js